import { useState } from "react";
import TopRibbon from "../components/TopRibbon";
import Loading from '../components/Loading';
import "./Register.css";

function Register() {
    const [statusMessage, setStatusMessage] = useState("Please fill in the form to continue.");
    const [isLoading, setIsLoading] = useState(false);
    const [btnVisible, setBtnVisible] = useState(true);

    async function sendRegister(email, pw, pwConfirm, fName, lName) {
        setIsLoading(true)
        try {
            const request = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    'x-api-key': process.env.REACT_APP_API_KEY
                },
                body: JSON.stringify({
                    email: email,
                    password: pw,
                    password_confirm: pwConfirm,
                    firstName: fName,
                    lastName: lName,
                })
            };
            const result = await fetch(`${process.env.REACT_APP_API_URL}/register`, request);
            const response = await result.json();

            setStatusMessage(response.message);

            if (result.status === 201) {
                setBtnVisible(false);
            };

        } catch {
            setStatusMessage("Register is not available at the moment...");
        }
        setIsLoading(false);
    }

    function submitClick(e) {
        e.preventDefault();
        const fNameInput = document.getElementById("register--name");
        const lNameInput = document.getElementById("register--last-name");
        const emailInput = document.getElementById("register--email");
        const pwInput = document.getElementById("register--pw");
        const pwConfirmInput = document.getElementById("register--pw-confirm");

        if (!fNameInput.checkValidity()) {
            setStatusMessage("Name must have between 2 and 16 characters.");
            return
        }

        if (!lNameInput.checkValidity()) {
            setStatusMessage("Last name must have between 2 and 16 characters.");
            return
        }

        if (!emailInput.checkValidity()) {
            setStatusMessage("Please add a valid email address.");
            return
        }

        if (!pwInput.checkValidity()) {
            setStatusMessage("Password must have between 8 and 32 characters.");
            return
        }

        if (pwInput.value !== pwConfirmInput.value) {
            setStatusMessage("Verify passwords match.");
            return
        }

        sendRegister(emailInput.value, pwInput.value, pwConfirmInput.value, fNameInput.value, lNameInput.value);
    }

    function validateInput(e) {
        const validationCircle = document.getElementById(e.target.id + "-val");
        if (e.target.checkValidity()) {
            validationCircle.style.backgroundColor = "rgb(138, 182, 243)";
        } else {
            validationCircle.style.backgroundColor = "rgb(218, 200, 221)";
        }
    }

    return (
    <>
        <TopRibbon title="Register ✨" />
        <div className="register--container">
            <div className="register--body fade-in-up">
                <form className="register--form">
                    <div className="form--validation-circle" id="register--name-val"></div><input type="text" placeholder="Name" id="register--name" minLength={2} maxLength={16} onChange={validateInput} autoComplete="given-name" required />
                    <div className="form--validation-circle" id="register--last-name-val"></div><input type="text" placeholder="Last Name" id="register--last-name" minLength={2} maxLength={16} onChange={validateInput} autoComplete="family-name" required />
                    <div className="form--validation-circle" id="register--email-val"></div><input type="email" id="register--email" pattern="[A-Za-z0-9._\-']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}" size="20" placeholder="Email" onChange={validateInput} autoComplete="username" required />
                    <div className="form--validation-circle" id="register--pw-val" ></div><input type="password" id="register--pw" size="20" minLength={8} maxLength={32} placeholder="Password" onChange={validateInput} autoComplete="new-password" required />
                    <div className="form--validation-circle" id="register--pw-confirm-val"></div><input type="password" id="register--pw-confirm" size="20" minLength={8} maxLength={32} placeholder="Re-enter password" onChange={validateInput} autoComplete="new-password" required />
                </form>
                <div className="register--status">{isLoading ? <Loading /> : statusMessage}</div>
                <div className="register--submit">{btnVisible && <button className="register--submit-btn" onClick={submitClick}>Submit</button>} </div>
            </div>
        </div>
    </>
    )
};

export default Register;